import { render, staticRenderFns } from "./ReportLostStolen.vue?vue&type=template&id=fb072a54&"
import script from "./ReportLostStolen.vue?vue&type=script&lang=js&"
export * from "./ReportLostStolen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports